module.exports = __webpack_public_path__ + "static/media/study 220221.26bee852.png";